import { IMAGES } from "@/lib/constants";
import { Overline } from "@/components/site/Primitives";
import { NewsletterSection } from "@/components/site/Newsletter";

export default function NewsletterPage() {
  return (
    <div data-testid="newsletter-page">
      <section className="relative h-[45vh]">
        <img src={IMAGES.seasonalBanner} alt="Wildflowers" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-brand-charcoal/35" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div>
            <Overline className="text-brand-cream">Letters from the Cottage</Overline>
            <h1 className="text-5xl sm:text-6xl font-light text-brand-cream mt-4 leading-none">The Newsletter</h1>
          </div>
        </div>
      </section>
      <section className="max-w-2xl mx-auto px-6 py-20 text-center">
        <p className="font-body text-brand-body text-lg leading-relaxed">
          A fortnightly letter written by my own hand — a seasonal recipe, a herbal remedy, a page from the journal,
          and a small thought to carry you gently through the days. It is free, and always will be.
        </p>
      </section>
      <NewsletterSection />
    </div>
  );
}
